/* eslint-disable no-undef */
(function (window) {
	"use strict";
	function defineHeartbeatService() {
		var heartbeatService = {};
		heartbeatService.getHeartbeats = function (pageNumber, pageSize, heartbeatStatusCodeId, componentId, heartbeatInstanceId) {
			console.log("pageSize", pageSize);
			var url = "/api/heartbeatService/GetHeartbeats?pageNum=" + pageNumber + "&pageSize=" + pageSize;
			if(componentId){
				url += "&componentId=" + applicationComponentId;
			}
			if(heartbeatInstanceId){
				url += "&heartbeatInstanceId=" + heartbeatInstanceId;
			}
			if(heartbeatStatusCodeId){
				url += "&heartbeatStatusCodeId=" + heartbeatStatusCodeId;
			}
			return axios.get(url);
		};
		heartbeatService.getHeartbeatsSinceTime = function (withLastSeconds, componentId, heartbeatInstanceId, heartbeatStatusCodeId) {
			var url = "/api/heartbeatService/GetHeartbeatsSinceTime?withLastSeconds=" + withLastSeconds;
			if(componentId){
				url += "&applicationComponentId=" + applicationComponentId;
			}
			if(heartbeatInstanceId){
				url += "&heartbeatInstanceId=" + heartbeatInstanceId;
			}
			if(heartbeatStatusCodeId){
				url += "&heartbeatStatusCodeId=" + heartbeatStatusCodeId;
			}
			return axios.get(url);
		};
		heartbeatService.getHeartbeatsStatusTotalSummary = function (withLastSeconds) {
			return axios.get("/api/heartbeatService/GetHeartbeatsStatusTotalSummary?withLastSeconds=" + withLastSeconds);
		};
		heartbeatService.getHeartbeatsStatusTotalSummaryForNumberOfDays = function (numberOfDays) {
			return axios.get("/api/heartbeatService/GetHeartbeatsStatusTotalSummaryForNumberOfDays?numberOfDays=" + numberOfDays);
		};
		return heartbeatService;
	}
	//define globally if it doesn't already exist
	if (typeof (heartbeatService) === "undefined") {
		window.heartbeatService = defineHeartbeatService();
	} else {
		console.log("heartbeatService already defined.");
	}
})(window);